const CheckKey = (obj, keyName) =>
  Object.keys(obj).some(key => key === keyName);

export default CheckKey;
